var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "560px",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-end az-gap-small mt-4"
                },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loading },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" Salvar ")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v("Editar participantes")
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("BaseValidationForm", { ref: "form" }, [
              _c(
                "div",
                { ref: "rows" },
                _vm._l(_vm.rows, function(row, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "d-flex align-center az-gap-small mb-2"
                    },
                    [
                      _c("InputByType", {
                        staticClass: "flex-grow-1",
                        attrs: {
                          type: "text",
                          placeholder: "Nome",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: row.nome,
                          callback: function($$v) {
                            _vm.$set(row, "nome", $$v)
                          },
                          expression: "row.nome"
                        }
                      }),
                      _c("InputByType", {
                        staticClass: "flex-grow-1",
                        attrs: {
                          type: "text",
                          placeholder: "E-mail (opcional)",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: row.email,
                          callback: function($$v) {
                            _vm.$set(row, "email", $$v)
                          },
                          expression: "row.email"
                        }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeRow(i)
                                              }
                                            }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "trash",
                                            size: 16,
                                            color: "var(--muted)"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("span", [_vm._v("Remover")])]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass:
                    "transcript-participants-modal__add az-text-small mt-1",
                  on: { click: _vm.addRow }
                },
                [_vm._v(" + Adicionar participante ")]
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }